module.exports = __webpack_public_path__ + "static/banner-3-f72b6ec4f7927e4dd1da101f5d99686e.png";